
import dayjs from '~/utils/dayjs'
export default {
  name: 'TemplatesPagesGroup',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    imgBase() {
      if (!this.group.image) {
        return null
      }

      return `${this.$config.CDN_URL}eventgroup/${this.id}/${this.group.image}`
    }
  },
  methods: {
    isLocation(event) {
      const { location } = event
      if (!location || Array.isArray(location) || !location.title) {
        return null
      }

      const { title, address } = location
      const isObj = address && typeof address === 'object'
      const street = isObj
        ? (address.street || null)
        : (typeof address === 'string' ? address : null)
      const city = isObj ? (address.city || null) : null
      const country = isObj ? (address.country || null) : null

      const norm = (v) => (v || '').trim().toLowerCase()
      const titleEqualsStreet = street && norm(title) === norm(street)

      const parts = titleEqualsStreet
        ? [street, city, country]
        : [title, street, city, country]

      const text = parts.filter(Boolean).join(', ')
      return text ? { text } : null
    },
    parseDate(date) {
      const _date = dayjs(date)
      return {
        month: '',
        day: _date.date(),
        year: _date.year()
      }
    },
    salesFrom(date) {
      return dayjs(date).toDate()
    },
    headingDate(date) {
      return dayjs(date).toDate()
    }
  }
}
